import {ISODate} from "./date"
import {ItemCode, WarehouseCode} from "./api/types"
import {PurchaseOrderLine} from "./api/purchaseorder"
import {SalesOrderLine} from "./api/salesorder"
import {WarehouseTransferLine} from "./api/warehousetransfer"
import {PlannedSalesReturnLine} from "./api/plannedsalesreturn"

type Source = PurchaseOrderLine
  | SalesOrderLine
  | WarehouseTransferLine
  | PlannedSalesReturnLine

export class ItemWarehousePlanningDetails {

  constructor(
    readonly itemCode: ItemCode,
    readonly plannedDate: ISODate,
    readonly plannedQuantity: number,
    readonly warehouseCode: WarehouseCode,
    readonly planningSource: Source,
  ) { }

  getPlanningSourceType(): string {
    const source = this.planningSource
    return source instanceof PurchaseOrderLine ? "PurchaseOrder"
    : source instanceof SalesOrderLine ? "SalesOrder"
    : source instanceof PlannedSalesReturnLine ? "PlannedSalesReturn"
    : (this.plannedQuantity > 0 ? "WarehouseTransfer-in" : "WarehouseTransfer-out")
  }

  getPlanningSourceTypeShort(): string {
    const source = this.planningSource
    return source instanceof PurchaseOrderLine ? "PO"
    : source instanceof SalesOrderLine
      ? (source.quantity < 0 ? "Trade-in" : "SO")
    : source instanceof PlannedSalesReturnLine ? "return"
    : (this.warehouseCode === source.parent.warehouseToCode ? "WT-in" : "WT-out")
  }

  getOtherParty(): string {
    const source = this.planningSource
    return source instanceof PurchaseOrderLine ? source.parent.supplierName
    : source instanceof SalesOrderLine ? source.parent.orderedByName
    : source instanceof PlannedSalesReturnLine ? "return"
    : (this.warehouseCode === source.parent.warehouseToCode ?
      source.parent.warehouseFromDescription : source.parent.warehouseToDescription)
  }


  getPlanningSourceNumber(): number {
    const source = this.planningSource
    return source instanceof PurchaseOrderLine ? source.parent.orderNumber
    : source instanceof SalesOrderLine ? source.parent.orderNumber
    : source instanceof PlannedSalesReturnLine ? source.parent.returnNumber
    : source.parent.transferNumber
  }

  getUniqueKey(): string {
    return this.getPlanningSourceType() + "_" + this.getPlanningSourceNumber()
    + "_" + this.planningSource.lineNumber
  }
}


